import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

const ITEMS_ES = [
  'Envío GRATIS',
  'Telas Premium',
  'Todas las Tallas',
  'Mejores Precios',
  '100% Mehadrin',
  'Soft Wool',
  'Quality Cotton',
  'Dry-Fit',
  'Adulto y Niño',
  'Máxima Calidad',
  'Certificados',
];

const ITEMS_EN = [
  'FREE Shipping',
  'Premium Fabrics',
  'All Sizes',
  'Best Prices',
  '100% Mehadrin',
  'Soft Wool',
  'Quality Cotton',
  'Dry-Fit',
  'Adult & Kids',
  'Highest Quality',
  'Certified',
];

const ITEMS_HE = [
  'משלוח חינם',
  'בדים פרימיום',
  'כל המידות',
  'המחירים הטובים ביותר',
  '100% מהדרין',
  'צמר רך',
  'כותנה איכותית',
  'דריי-פיט',
  'מבוגרים וילדים',
  'איכות מקסימלית',
  'מוסמכים',
];

const TrustBand = () => {
  const { language } = useLanguage();
  const items = language === 'es' ? ITEMS_ES : language === 'he' ? ITEMS_HE : ITEMS_EN;
  // Duplicate for seamless loop
  const doubled = [...items, ...items];

  return (
    <div className="bg-slate-900 border-y border-slate-800/60 py-3 overflow-hidden" data-testid="trust-band">
      <div className="hero-marquee">
        <div className="hero-marquee-track">
          {doubled.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center whitespace-nowrap mx-6 lg:mx-10">
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-500/50 mr-4 lg:mr-6 flex-shrink-0" />
              <span className="text-xs lg:text-sm text-slate-400 font-medium tracking-wide uppercase">
                {item}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBand;
